// PageHero.js - Hero superior de páginas internas (imagen editable desde CMS)
import React from 'react';

const DEFAULT_HERO_IMAGE = `${process.env.PUBLIC_URL || ''}/IMG_8956.JPG`;

/**
 * @param {string} [imageUrl] imagen de fondo (CMS)
 * @param {string} title
 * @param {string} [subtitle]
 * @param {string} [eyebrow] texto pequeño con letras huecas sobre el título
 */
/*
 * imageUrl:
 *   undefined → todavía se está consultando el CMS: fondo oscuro, sin imagen (evita mostrar
 *               una imagen de respaldo que luego cambia)
 *   null      → el CMS no tiene imagen para esta página: se usa la de respaldo
 *   string    → imagen del CMS
 */
const PageHero = ({ imageUrl, title, subtitle, eyebrow }) => {
  const overlay = 'linear-gradient(90deg, rgba(0,0,0,.92) 0%, rgba(0,0,0,.72) 55%, rgba(0,0,0,.4) 100%)';
  const bgImage = imageUrl === undefined ? null : (imageUrl || DEFAULT_HERO_IMAGE);
  return (
    <section
      className="ach-page-hero"
      style={{
        backgroundImage: bgImage ? `${overlay}, url(${bgImage})` : overlay,
      }}
    >
      <div className="ach-page-hero-inner">
        {eyebrow && <span className="ach-eyebrow-outline ach-page-hero-eyebrow">{eyebrow}</span>}
        <h1 className="ach-display ach-page-hero-title">{title}</h1>
        {subtitle && <p className="ach-page-hero-subtitle">{subtitle}</p>}
      </div>
      <style>{`
        .ach-page-hero {
          background-color: #0a0a0a;
          background-size: cover;
          background-position: center 35%;
          background-repeat: no-repeat;
          color: #fff;
          padding: clamp(64px, 8vw, 96px) clamp(16px, 8vw, 128px) clamp(64px, 7vw, 88px);
          margin-bottom: 48px;
        }
        .ach-page-hero-inner { max-width: 1180px; margin: 0 auto; }
        .ach-page-hero-eyebrow { font-size: 1rem; margin-bottom: 14px; }
        .ach-page-hero-title { margin: 0; font-size: clamp(2.1rem, 5vw, 3.5rem); color: #fff; }
        .ach-page-hero-subtitle {
          margin: 16px 0 0;
          max-width: 620px;
          font-size: 1.05rem;
          line-height: 1.6;
          color: #d4d4d4;
        }
      `}</style>
    </section>
  );
};

export default PageHero;
